export default __webpack_public_path__ + "static/2021_FINALIST-803ef9890d73d2f3504031ca6677d1f8.png";